import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Label, Header, Icon } from "semantic-ui-react";
import renderAst from "../../utils/ast-compiler";

export const FormQuestion = ({ index, intlId }) => (
  <label>
    <Label.Group circular as="span" color="grey">
      <Label>{index}</Label>
    </Label.Group>
    <FormattedMessage id={intlId} />
  </label>
);

export const Question = ({ node }) => (
  <Fragment>
    <Header as="h3">
      <Icon name="check circle outline" /> {node.frontmatter.title}
    </Header>
    <div style={{ padding: "1em", lineHeight: "1.6em" }}>
      {renderAst(node.htmlAst)}
    </div>
  </Fragment>
);